<template>
  <div class="v-container">
    <div class="v-page-header">节点管理</div>
    <div class="v-header">
      <el-button type="primary" size="small" @click="add()">
        <i class="el-icon-plus"></i>
        添加节点
      </el-button>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" :row-key="getRowKeys" border size="small" :row-style="rowStyle" style="width: 100%">
        <el-table-column width="80">
          <template slot-scope="scope" v-if="scope.row.parent_id > 0">
            <span style="color: #666; font-size: 12px">|--</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="50" />
        <el-table-column prop="sort" label="排序" width="180" />
        <el-table-column prop="title" label="方法名称" width="180" />
        <el-table-column prop="path" label="接口地址" />
        <el-table-column label="状态" width="70">
          <template slot-scope="scope">{{ scope.row.status == 0 ? '禁用' : '启用' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="添加子节点" placement="top">
              <el-button @click="add(scope.row)" :disabled="scope.row._level == 2" type="default" size="min" icon="el-icon-plus" />
            </el-tooltip>
            <el-button @click="edit(scope.row)" type="default" size="min" icon="el-icon-edit" />
            <el-button @click="del(scope.row)" :loading="scope.row.loading" type="default" size="min" icon="el-icon-delete" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <node-add-edit v-if="isShowAddEdit" :isShow.sync="isShowAddEdit" @success="getList" :addEditType="addEditType" :row="row" />
  </div>
</template>

<script>
import NodeAddEdit from './components/node-add-edit';

export default {
  name: 'permissionnode',
  components: { NodeAddEdit },
  data() {
    return {
      lists: [], // table数据
      isShowAddEdit: false, // 显示新增修改弹窗
      loading: false, // 页面loading
      addEditType: 1, // 1添加 2修改 3添加子类
      row: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },

    async getList() {
      try {
        this.loading = true;
        let res = await this.api.userAdmin.getPermission({ type: 2 });
        this.lists = res.data;
        this.loading = false;
      } catch (ex) {
        this.loading = false;
      }
    },

    add(row) {
      this.isShowAddEdit = true;
      this.row = row;
      this.addEditType = row && row.id ? 3 : 1;
    },

    edit(row) {
      this.isShowAddEdit = true;
      this.addEditType = 2;
      this.row = row;
    },

    del(row) {
      this.$confirm('确认删除么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          row.loading = true;
          try {
            let res = await this.api.userAdmin.deletePermission({ id: row.id });
            this.$message.success(res.message);
            row.loading = false;
            this.getList();
          } catch (ex) {
            row.loading = false;
          }
        })
        .catch(() => {});
    },

    rowStyle(data) {
      return data.row.pid > 0 ? 'background:#cccccc;' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.tool-bar {
  padding: 0 0 15px 0;
}
</style>
